var Flickity = require('flickity');
require('flickity-sync');
import UIkit from 'uikit';


const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {

  const viewport = this.element.querySelector('.flickity-viewport');
  if(viewport) {
    viewport.style.height = null;
    resize.call( this );
  }
};

const slider = () => {

	const elem = document.querySelectorAll('.glamy-slider');
	if(elem) {
		elem.forEach(element => {
			const flkty = new Flickity(element,{
				watchCSS: true,
				prevNextButtons: false
			});
		});
	}

	const ig = document.querySelectorAll('.c-instagram');
	if(ig) {
		ig.forEach(element => {
			const igFlkty = new Flickity(element,{
				watchCSS: false,
				cellAlign: 'left',
				wrapAround: true,
				contain: true,
				prevNextButtons: false
			});
		});
	}

	const gridSlider = document.querySelectorAll('.flickityGridSlider');
	if(gridSlider) {
		gridSlider.forEach(element => {

			const flickityGridSlider = new Flickity(element,{
				watchCSS: true,
				prevNextButtons: false
			});
		});
	}

	const simpleSlider = document.querySelectorAll('.flickitySlider');
	if(simpleSlider) {
		simpleSlider.forEach(element => {

			const flickitySimpleSlider = new Flickity(element,{
				watchCSS: false,
				prevNextButtons: true,
        wrapAround: true,
				cellAlign: 'left',
				arrowShape: 'M57.51.01c1.4 0 2.8.6 3.8 1.7 1.8 2.1 1.6 5.2-.5 7l-48.1 41.3 48.1 41.2c2.1 1.8 2.3 5 .5 7.1-1.8 2.1-5 2.3-7.1.5l-52.5-45c-1.1-.9-1.7-2.3-1.7-3.8s.6-2.8 1.7-3.8l52.5-45c1-.8 2.1-1.2 3.3-1.2z',
			});

      UIkit.util.on(document, 'shown', '.c-rooms__room', function() {
        flickitySimpleSlider.resize()
      });

		});
	}


	const productTabSlider = document.querySelectorAll('.c-producttab__carousel--nav');
	if(productTabSlider) {
		productTabSlider.forEach(element => {

			const flickityProductTabSlider = new Flickity(element,{
				watchCSS: true,
				sync: document.querySelector('.c-producttab__carousel--info'),
				adaptiveHeight: true,
				prevNextButtons: false
			});

			UIkit.util.on(document, 'shown', '#producttab', function() {
				flickityProductTabSlider.resize()
			});

		});
	}

	const productTabInfoSlider = document.querySelectorAll('.c-producttab__carousel--info');
	if(productTabInfoSlider) {
		productTabInfoSlider.forEach(element => {

			const flickityProductTabInfoSlider = new Flickity(element,{
				watchCSS: true,
        sync: document.querySelector('.c-producttab__carousel--nav'),
				draggable: true,
				pageDots: false,
				prevNextButtons: false
			});

			UIkit.util.on(document, 'shown', '#producttab', function() {
				flickityProductTabInfoSlider.resize()
			});

		});
	}

	const offerSliderNav = document.querySelector('.c-offerslider');
	if(offerSliderNav) {


			const flickityOfferSliderNav = new Flickity(offerSliderNav,{
				prevNextButtons: true,
				sync: document.querySelector('.c-offerslider--content'),
				initialIndex: 1,
				groupCells: 1,
				arrowShape: 'M57.51.01c1.4 0 2.8.6 3.8 1.7 1.8 2.1 1.6 5.2-.5 7l-48.1 41.3 48.1 41.2c2.1 1.8 2.3 5 .5 7.1-1.8 2.1-5 2.3-7.1.5l-52.5-45c-1.1-.9-1.7-2.3-1.7-3.8s.6-2.8 1.7-3.8l52.5-45c1-.8 2.1-1.2 3.3-1.2z',
			});

			flickityOfferSliderNav.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
				if ( typeof cellIndex == 'number' ) {
					flickityOfferSliderNav.select( cellIndex );
				}
			});


	}

	const offerSlider = document.querySelector('.c-offerslider--content');
	if(offerSlider) {


			const flickityOfferSlider = new Flickity(offerSlider,{
				prevNextButtons: false,
				draggable: false,
				pageDots: false,
				initialIndex: 1,
			});

	}


};

export default slider;
